import {useEffect, useRef, useState} from "react";
import iconFileTextOutline from "@iconify/icons-eva/file-text-outline";
import iconFileAddOutline from "@iconify/icons-eva/file-add-outline";
import iconPaperPlaneOutline from "@iconify/icons-eva/paper-plane-outline";
import MyPagination from "src/components/common/MyPagination";
// material
import {
  Card,
  Table,
  Stack,
  Avatar,
  Button,
  Checkbox,
  TableRow,
  TableBody,
  TableCell,
  Container,
  Typography,
  TableContainer,
  TablePagination,
  TextField,
  Divider,
  Grid,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  RadioGroup,
  Radio,
  FormControlLabel,
} from "@mui/material";
// components
import Page from "../../components/Page";
import Label from "../../components/Label";
import Scrollbar from "../../components/Scrollbar";
import SearchNotFound from "../../components/SearchNotFound";
import {OrderListToolbar} from "../../components/_dashboard/order";

import axios from "axios";
import moment from "moment";
import {
  DELIVERY_TYPE_MAP,
  PAY_METHODS,
  PAY_METHOD_MAP,
  STORE_ORDER_STATUS,
  STORE_ORDER_STATUS_MAP,
} from "src/config/constants";
import {alert} from "src/services/alert";
import MoreMenu from "src/components/common/MoreMenu";
import XLSX from "xlsx";
import FormDialog from "src/components/common/FormDialog";
import FormItem from "src/components/form-item/FormItem";
import ConvertUtil from "src/utils/ConvertUtil";
import Confirm from "src/components/common/ConfirmDialog";
import ListHead from "src/components/common/ListHead";
import OrderRecordsDialog from "src/components/dialogs/OrderRecordsDialog";
import {asyncRequest} from "src/services/network";
import OrderDetailDialog from "src/components/dialogs/OrderDetailDialog";
import UserInfo from "src/components/common/UserInfo";
import CellImage from "src/components/common/CellImage";
import {Icon} from "@iconify/react";
import plusFill from "@iconify/icons-eva/plus-fill";
import {LocalizationProvider} from "@mui/x-date-pickers/LocalizationProvider";
import {AdapterDayjs} from "@mui/x-date-pickers/AdapterDayjs";
import "dayjs/locale/zh-cn";
import {DateTimePicker} from "@mui/x-date-pickers/DateTimePicker";
import StoreProductPicker from "src/components/common/StoreProductPicker";
import ListToolbar from "src/components/common/ListToolbar";
// ----------------------------------------------------------------------
const payMethods = Object.values(PAY_METHODS);
const statuses = Object.values(STORE_ORDER_STATUS);
const statusesList = ["", "1", "2", "3", "4", "5"];
const statusesWap = {
  1: "门票",
  2: "年会专区",
  3: "大项目部",
  4: "积分兑换",
  5: "低保领取",
};
const prizeTypeList = ["", "1", "2"];
const prizeTypeWap = {
  1: "虚拟物品",
  2: "实物奖品",
};
const izUsedList = ["", "true", "false"];
const izUsedWap = {
  true: "使用",
  false: "未使用",
};
const handleList = ["", "false", "true"];
const handleWap = {
  false: "未处理",
  true: "已处理",
};
const TABLE_HEAD = [
  {
    id: "name",
    label: "中奖人ID",
    alignRight: false,
  },
  {
    id: "code",
    label: "抽奖码",
    alignRight: false,
  },
  {
    id: "codeType",
    label: "码类型",
    alignRight: false,
  },
  {
    id: "rewardName",
    label: "中奖名称",
    alignRight: false,
  },
  // {id: "buyCount", label: "购买数量", alignRight: false},
  // { id: "totalPrice", label: "商品总价(元)", alignRight: false },
  // { id: "price", label: "支付金额(元)", alignRight: false },
  // { id: "payMethod", label: "支付方式", alignRight: false },
  // { id: "status", label: "状态", alignRight: false },
  {
    id: "prizeType",
    label: "奖品类型",
    alignRight: false,
  },
  {
    id: "izUsed",
    label: "兑奖状态",
    alignRight: false,
  },
  {
    id: "orderSn",
    label: "收件信息",
    alignRight: false,
  },
  // { id: "receiverName", label: "收件人", alignRight: false },
  // { id: "receiverMobile", label: "收货人号码", alignRight: false },
  // { id: "receiverAddress", label: "收货地址", alignRight: false },
  // {id: "userRemark", label: "买家留言", alignRight: false},
  {
    id: "create_at",
    label: "中奖时间",
    alignRight: false,
  },
  // { id: "supplier", label: "供应商", alignRight: false },
  {
    id: "",
  },
];

const moreMenus = [
  {
    title: "去处理",
    icon: iconFileTextOutline,
  },
  // {title: "详情", icon: iconFileTextOutline},
  // {title: "记录", icon: iconFileTextOutline},
  // {title: "备注", icon: iconFileAddOutline},
  // {title: "发货", icon: iconPaperPlaneOutline, limit: [STORE_ORDER_STATUS.PAYED]},
  // // { title: "退款", icon: iconPaperPlaneOutline, limit: [STORE_ORDER_STATUS.REFUNDING] },
  // {title: "核销", icon: iconPaperPlaneOutline, limit: [STORE_ORDER_STATUS.PAYED]},
  // {
  //   title: "删除",
  //   icon: iconPaperPlaneOutline,
  //   limit: [STORE_ORDER_STATUS.FINISHED, STORE_ORDER_STATUS.DELETED, STORE_ORDER_STATUS.CANCELED]
  // },
];

export default function SupplierOrderList() {
  const [curOrder, setCurOrder] = useState({});
  const [action, setAction] = useState();
  const [remark, setRemark] = useState("");
  const [deliverySN, setDeliverySN] = useState(""); // 物流信息
  const [verifyCode, setVerifyCode] = useState(""); // 核销码
  const [orders, setOrders] = useState([]);
  const [records, setRecords] = useState([]);
  const [totalItems, setTotalItems] = useState(0);
  const [countMap, setCountMap] = useState({});
  const [product, setProduct] = useState({});
  const [itemObj, setItemObj] = useState({});

  const uploadRef = useRef();
  const [form, setForm] = useState({
    pid: "",
    isShow: true,
    receiverName: "",
    receiverMobile: "",
    receiverAddress: "",
    remark: "",
  });
  const [productForm, setProductForm] = useState({
    count: '',
    codeType: '',
    mobile: '',
    partyVersion: '',
    password: ''
  });
  const codeTypeList = ["1", "2", "3", "4"];
  const codeTypeNum = {
    1: '门票',
    2: '活动专区',
    3: '大项目部',
    4: '其他',
  };
  const partyVersionList = ["202603", "202602", "202601"];
  const partyVersionWrap = {
    202603: "2026马年七天乐",
    202602: "2026黄金答谢宴",
    202601: "2026云南旅游",
  };
  const [filter, setFilter] = useState({
    page: 0,
    size: 20,
    status: [],
    payMethod: -1,
    search: "",
    productId: null,
    orderSN: "",
    receiverMobile: "",
    startTime: null,
    endTime: null,
    codeType: "",
    code: "",
    prizeType: "2",
    izUsed: "",
    uid: "",
    izProcess: "",
    partyVersion: "202602",
  });

  useEffect(() => {
    getOrders();
  }, [filter]);

  async function getOrders() {
    const result =
      (await asyncRequest({
        // path: "/store/order/list",
        path: "/meeting/2026/codes",
        data: filter,
      })) || {};
    console.log(99999);
    console.log(result);
    const data = result.data || [];
    const count = result.count || 0;
    // const counts = result.counts || [];
    console.log(data);
    const counts = [];
    setOrders(
      data.map((d) => ({
        ...d,
        createdAt: moment(d.createdAt).format("YYYY-MM-DD HH:mm:ss"),
        // payTime: d.payTime ? moment(d.payTime).format("YYYY-MM-DD HH:mm:ss") : d.payTime,
        // productData: JSON.parse(d.productData) || [],
        // productName: JSON.parse(d.productData)[0].name,
      })),
    );
    setTotalItems(count);

    // const map = {};
    // for (let i = 0; i < counts.length; i++) {
    //   map[counts[i].status] = counts[i].count;
    // }
    // setCountMap(map);
  }

  function handleSearch(val) {
    setFilter({
      ...filter,
      search: val,
    });
  }

  function handleLotteryCodes(val) {
    setProductForm({
      ...productForm,
      count: '',
      codeType: '',
      mobile: '',
      partyVersion: '',
      password: ''
    });
    setAction("addCodes");
  }


  const handleChangePage = (event, newPage) => {
    setFilter({
      ...filter,
      page: newPage,
    });
  };

  const handleChangeRowsPerPage = (event) => {
    setFilter({
      ...filter,
      size: parseInt(event.target.value, 10),
      page: 1,
    });
  };
  const handlePageChange = (event, value, newSize) => {
    if (newSize !== undefined) {
      setFilter({ ...filter, page: 0, size: newSize });
      return;
    }
    const newPage = value - 1;
    if (newPage === filter.page) return;
    setFilter({
      ...filter,
      page: newPage,
    });
  };

  function handleSizeChange(value) {
    setFilter({
      ...filter,
      size: value,
    });
  }

  function handleDateChange(dateRange) {
    setFilter({
      ...filter,
      createdAt: dateRange,
    });
  }

  function handleStatusChange(status) {
    setFilter({
      ...filter,
      status,
    });
  }

  // 操作条
  async function handleDownload() {
    const {data, msg} = await asyncRequest({
      path: "/meeting/2026/codes/export",
      data: filter,
    });

    alert(msg, "success");
  }

  function exportOrders(orders) {
    const alphabets = "ABCDEFGHIJKLMNOPQRSTUVWXYZ".split("");
    const cellTitles = [
      "订单号",
      "收货人姓名",
      "收货人电话",
      "收货地址",
      "商品编号",
      "中奖名称",
      "数量",
      "下单时间",
      "支付状态",
      "支付时间",
      "用户备注",
      "管理员备注",
      "物流单号",
      "快递公司",
    ];
    const cellKeys = [
      "orderSN",
      "receiverName",
      "receiverMobile",
      "receiverAddress",
      "productId",
      "productName",
      "createdAt",
      "buyCount",
      "status",
      "payTime",
      "userRemark",
      "adminRemark",
      "deliverySN",
      "deliveryCompany",
    ];
    const header = alphabets.slice(0, cellTitles.length);

    const data = [{}];
    for (let i = 0; i < header.length; i++) {
      const alphabet = header[i];
      data[0][alphabet] = cellTitles[i];

      let j = 1;

      orders.forEach((order) => {
        let productIdx = 0;
        order.productData.forEach((product) => {
          if (!data[j]) {
            data[j] = {};
          }

          const obj = {
            ...order,
            productId: product.id,
            productName: product.name,
            status: ConvertUtil.getOrderStatusText(order.status),
            payMethod: PAY_METHOD_MAP[order.payMethod],
            count: product.count,
          };
          data[j][alphabet] = obj[cellKeys[i]];

          j++;
          productIdx++;
        });
      });
    }

    var ws = XLSX.utils.json_to_sheet(data, {
      header,
      skipHeader: true,
    });

    var workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, ws, "订单信息");

    XLSX.writeFile(workbook, `订单导出${Date.now()}.xlsx`);
  }

  function filterMoreMenus(status) {
    const menus = [];
    for (let i = 0; i < moreMenus.length; i++) {
      if (moreMenus[i].limit && !moreMenus[i].limit.includes(status)) {
        continue;
      }

      menus.push(moreMenus[i]);
    }

    return menus;
  }

  function handleFilterChange(ki, val) {
    setFilter({
      ...filter,
      page: 0,
      [ki]: val,
    });
  }

  function handleReset() {
    setFilter({
      page: 0,
      size: 20,
      status: [],
      payMethod: -1,
      productId: null,
      orderSN: "",
      receiverMobile: "",
      startTime: null,
      endTime: null,
      codeType: "",
      code: "",
      prizeType: "2",
      izUsed: "",
      uid: "",
      izProcess: "",
      partyVersion: "202603",
    });
  }

  async function getOrderRecords(orderSN) {
    const {data} = await asyncRequest({
      path: "/store/order/records",
      data: {
        orderSN,
      },
    });

    setRecords(data);
    setAction("records");
  }

  async function getOrderRecordstatus(orderSN) {
    const {data} = await asyncRequest({
      path: "/meeting/2026/codes/" + orderSN + "/process",
      data: {
        orderSN,
      },
    });
    getOrders();
  }

  async function getOrderRecordstatusTwo(item) {
    setItemObj(item);
    setForm({
      pid: "",
      isShow: true,
      receiverName: item.receiverName || "",
      receiverMobile: item.receiverMobile || "",
      receiverAddress: item.receiverAddress || "",
      remark: item.remark || "",
    });
    setAction("tohandle");
  }

  function handleIptChange(ki, val) {
    setForm({
      ...form,
      [ki]: val,
    });
  }

  function handleIptChangeTwo(ki, val) {
    setProductForm({
      ...productForm,
      [ki]: val,
    });
  }

  // 更多操作
  function handleMoreClick(title, row, ...args) {
    if (title === "详情") {
      setCurOrder(row);
      setAction("detail");
    } else if (title === "记录") {
      // setAction("records");
      getOrderRecords(row.orderSN);
    } else if (title === "去处理") {
      // setAction("records");
      getOrderRecordstatus(row.orderSN);
    } else if (title === "发货") {
      setCurOrder(row);
      setAction("delivery");
    } else if (title === "备注") {
      setCurOrder(row);
      setRemark(row.adminRemark);
      setAction("remark");
    } else if (title === "核销") {
      // hexiao(row.orderSN);
      setCurOrder(row);
      setAction("hexiao");
    } else if (title === "删除") {
      delRow(row.orderSN);
    } else if (title === "确认支付") {
      confirmPay(row.orderSN);
    }
  }

  function Details(row) {
    getOrderRecordstatusTwo(row);
  }

  async function handleDialogConfirm() {
    if (action === "remark") {
      setAdminRemark();
    } else if (action === "delivery") {
      fahuo();
    } else if (action === "tohandle") {
      // 处理表单提交
      const dataToSubmit = {
        ...form,
        pid: form.pid ? form.pid : "", // 如果pid是数字，在这里转换
        productId: form.pid ? form.pid : "",
      };
      // console.log("提交数据:", dataToSubmit);
      let result = await asyncRequest({
        path: "/meeting/2026/codes/" + itemObj.id + "/process",
        data: {
          ...dataToSubmit,
        },
      });
      // 处理结果
      if (result.code == 1) {
        alert(result.msg, "success");
        getOrders(); // 刷新数据
        setAction(); // 关闭对话框
        resetForm(); // 重置表单
      }
    } else if (action === "addCodes") {
      if (!productForm.count) {
        alert('请输入抽奖码数量');
        return;
      } else if (!productForm.codeType) {
        alert('请选择码类型');
        return;
      } else if (!productForm.mobile) {
        alert('请输入手机号');
        return;
      } else if (!productForm.partyVersion) {
        alert('请选择活动类型');
        return;
      } else if (!productForm.password) {
        alert('请输入操作密码');
        return;
      }
      // 处理表单提交
      const dataToSubmit = {
        ...productForm,
      };
      // console.log("提交数据:", dataToSubmit);
      let result = await asyncRequest({
        path: "/meeting/2026/chance/add",
        data: {
          ...dataToSubmit,
        },
      });
      // 处理结果
      if (result.code == 1) {
        alert(result.msg, "success");
        getOrders(); // 刷新数据
        setAction(); // 关闭对话框
        resetForm(); // 重置表单
      }
    }
  }

  function resetForm() {
    setForm({
      pid: "",
      isShow: true,
      receiverName: "",
      receiverMobile: "",
      receiverAddress: "",
      remark: "",
    });
  }

  async function handleConfirmHexiao() {
    const {data} = await asyncRequest({
      path: "/store/order/hexiao",
      data: {
        orderSN: curOrder.orderSN,
        verifyCode,
      },
    });

    getOrders();
    setAction();
  }

  async function setAdminRemark() {
    const {data} = await asyncRequest({
      path: "/store/order/remark",
      data: {
        orderSN: curOrder.orderSN,
        remark,
      },
    });

    orders.find((t) => t.orderSN === curOrder.orderSN).adminRemark = remark;
    setOrders([...orders]);

    setAction();
  }

  async function fahuo() {
    const {data} = await asyncRequest({
      path: "/store/order/fahuo",
      data: {
        orderSN: curOrder.orderSN,
        deliverySN: deliverySN,
      },
    });

    setOrders(orders.filter((t) => t.orderSN !== curOrder.orderSN));
    setAction();
    setDeliverySN("");
  }

  async function confirmPay(orderSN) {
    const {msg} = await asyncRequest({
      path: "/store/order/confirmPay",
      data: {
        orderSN,
      },
    });

    setOrders(orders.filter((t) => t.orderSN !== orderSN));
    alert(msg, "success");
  }

  function refund(orderSN) {
    Confirm({
      message: "确认退款吗？",
      async onConfirm() {
        const {data, msg} = await asyncRequest({
          path: "/store/order/refund",
          data: {
            orderSN,
          },
        });

        setOrders(orders.filter((t) => t.orderSN !== orderSN));
        alert(msg, "success");
      },
    });
  }

  function delRow(orderSN) {
    Confirm({
      message: "确定删除该条数据吗?",
      async onConfirm() {
        const {data, msg} = await asyncRequest({
          path: "/store/order/del",
          data: {
            orderSN,
          },
        });

        setOrders(orders.filter((t) => t.orderSN !== orderSN));
        alert(msg, "success");
      },
    });
  }

  function handleUpload(e, type) {
    console.log(e);
    if (!e.target.files[0]) return;
    let reader = new FileReader();
    reader.onload = (event) => {
      uploadRef.current.value = null;
      try {
        // 判断文件类型是否正确
        // if (".xls" != suffix && ".xlsx" != suffix) {
        //     message.error("选择Excel格式的文件导入!");
        //     return false;
        // }
        let {result} = event.target;
        // 读取文件
        let workbook = XLSX.read(result, {
          type: "binary",
        });
        let data = [];
        // 循环文件中的每个表
        let loaded = false;
        for (let sheet in workbook.Sheets) {
          // console.log('sheet: ', sheet);
          // if (workbook.Sheets.hasOwnProperty(sheet)) {
          //   // 将获取到表中的数据转化为json格式
          // }
          if (loaded) continue;

          const sheetData = XLSX.utils.sheet_to_json(workbook.Sheets[sheet], {
            defval: "",
          });
          console.log(sheetData);
          // setInitialData(sheetData);
          // setShowImportDialog(true);
          if (type === "settle") {
            handleBulkSettle([...sheetData]);
          } else {
            handleBulkSend([...sheetData]);
          }
          loaded = true;
        }
        // console.log("data:", data);
      } catch (e) {
        console.log(e);
        alert("文件类型不正确！");
      }
    };
    reader.readAsBinaryString(e.target.files[0]);
    // console.log(e.target.files[0])
  }

  function handleBulkSend(items) {
    Confirm({
      message: "确定批量发货吗？",
      async onConfirm() {
        const orders = [];

        for (let index = 0; index < items.length; index++) {
          const order = items[index];

          if (!order["物流单号"]) continue;

          orders.push({
            orderSN: order["订单号"],
            deliverySN: order["物流单号"],
            deliveryCompany: order["物流公司"],
          });
        }

        console.log(orders, items);

        // return;

        const {msg} = await asyncRequest({
          path: "/store/order/bulkFahuo",
          data: {
            orders,
          },
        });

        alert(msg, "success");
        getOrders();
      },
    });
  }

  function handleBulkSettle(items) {
    Confirm({
      message: "确定批量设置对账状态吗？",
      async onConfirm() {
        const orders = [];
        for (let index = 0; index < items.length; index++) {
          const order = items[index];
          orders.push({
            orderSN: order["订单号"],
            isSettle: order["是否对账"],
          });
        }
        console.log(orders, items);
        const {msg} = await asyncRequest({
          path: "/store/order/bulk/settle",
          data: {
            orders,
          },
        });
        alert(msg, "success");
        getOrders();
      },
    });
  }

  // const emptyRows = page > 0 ? Math.max(0, (1 + page) * rowsPerPage - orders.length) : 0;
  const emptyRows = 0;

  return (
    <Page title="商城订单">
      <Container maxWidth="2000px">
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="space-between"
          mb={5}
        >
          <Typography variant="h4" gutterBottom>
            年会抽奖{" "}
          </Typography>{" "}
        </Stack>
        <Card>
          <ListToolbar
            total={totalItems}
            countMap={countMap}
            onDateChange={handleDateChange}
            onStatusChange={handleStatusChange}
            onSearch={handleSearch}
            onExport={handleDownload}
            onRefresh={getOrders}
            onReset={handleReset}
            onLotteryCodes={handleLotteryCodes}
          >
            <Grid container gap={2}>
              <Grid item>
                <TextField
                  style={{
                    width: 200,
                  }}
                  label="uid"
                  placeholder="uid"
                  autoComplete="off"
                  id="receiverMobile"
                  size="small"
                  value={filter.uid}
                  onChange={(evt) => {
                    handleFilterChange("uid", evt.target.value);
                  }}
                />{" "}
              </Grid>
              <Grid item>
                <TextField
                  style={{
                    width: 200,
                  }}
                  label="抽奖码"
                  placeholder="抽奖码"
                  autoComplete="off"
                  id="orderSN"
                  size="small"
                  value={filter.code}
                  onChange={(e) => {
                    handleFilterChange("code", e.target.value);
                  }}
                />{" "}
              </Grid>{" "}
              <Grid item>
                <FormControl size="small">
                  <InputLabel> 码类型 </InputLabel>{" "}
                  <Select
                    label="码类型"
                    value={filter.codeType}
                    onChange={(e) => {
                      setFilter({
                        ...filter,
                        codeType: e.target.value,
                      });
                    }}
                    style={{
                      width: 250,
                    }}
                  >
                    {statusesList.map((type, idx) => (
                      <MenuItem key={idx} value={type} name={type}>
                        {" "}
                        {idx === 0 ? "全部" : statusesWap[type]}{" "}
                      </MenuItem>
                    ))}{" "}
                  </Select>{" "}
                </FormControl>{" "}
              </Grid>{" "}
              <Grid item>
                <FormControl size="small">
                  <InputLabel> 奖品类型 </InputLabel>{" "}
                  <Select
                    label="码类型"
                    value={filter.prizeType}
                    onChange={(e) => {
                      setFilter({
                        ...filter,
                        prizeType: e.target.value,
                      });
                    }}
                    style={{
                      width: 250,
                    }}
                  >
                    {prizeTypeList.map((type, idx) => (
                      <MenuItem key={idx} value={type} name={type}>
                        {" "}
                        {idx === 0 ? "全部" : prizeTypeWap[type]}{" "}
                      </MenuItem>
                    ))}{" "}
                  </Select>{" "}
                </FormControl>{" "}
              </Grid>{" "}
              <Grid item>
                <FormControl size="small">
                  <InputLabel> 兑奖状态 </InputLabel>{" "}
                  <Select
                    label="兑奖状态"
                    value={filter.izUsed}
                    onChange={(e) => {
                      setFilter({
                        ...filter,
                        izUsed: e.target.value,
                      });
                    }}
                    style={{
                      width: 250,
                    }}
                  >
                    {izUsedList.map((type, idx) => (
                      <MenuItem key={idx} value={type} name={type}>
                        {" "}
                        {idx === 0 ? "全部" : izUsedWap[type]}{" "}
                      </MenuItem>
                    ))}{" "}
                  </Select>{" "}
                </FormControl>{" "}
              </Grid>{" "}
              <Grid item>
                <FormControl size="small">
                  <InputLabel> 处理标志 </InputLabel>{" "}
                  <Select
                    label="处理标志"
                    value={filter.izProcess}
                    onChange={(e) => {
                      setFilter({
                        ...filter,
                        izProcess: e.target.value,
                      });
                    }}
                    style={{
                      width: 250,
                    }}
                  >
                    {handleList.map((type, idx) => (
                      <MenuItem key={idx} value={type} name={type}>
                        {" "}
                        {idx === 0 ? "全部" : handleWap[type]}{" "}
                      </MenuItem>
                    ))}{" "}
                  </Select>{" "}
                </FormControl>{" "}
              </Grid>{" "}
              <Grid item>
                <FormControl size="small">
                  <InputLabel> 活动类型 </InputLabel>{" "}
                  <Select
                    label="活动类型"
                    value={filter.partyVersion}
                    onChange={(e) => {
                      setFilter({
                        ...filter,
                        partyVersion: e.target.value,
                      });
                    }}
                    style={{
                      width: 250,
                    }}
                  >
                    {partyVersionList.map((type, idx) => (
                      <MenuItem key={idx} value={type} name={type}>
                        {partyVersionWrap[type]}
                      </MenuItem>
                    ))}{" "}
                  </Select>{" "}
                </FormControl>{" "}
              </Grid>{" "}
            </Grid>{" "}
          </ListToolbar>
          <Scrollbar>
            <TableContainer
              sx={{
                minWidth: 800,
              }}
            >
              <Table>
                <ListHead headLabel={TABLE_HEAD}/>{" "}
                <TableBody>
                  {orders.map((row) => {
                    const {
                      id,
                      uid,
                      code,
                      payPrice,
                      payMethod,
                      codeType,
                      prizeType,
                      izProcess,
                      izUsed,
                      totalPrice,
                      buyCount,
                      productData,
                      createdAt,
                      status,
                      orderSN,
                      userRemark,
                      receiverAddress,
                      receiverName,
                      receiverMobile,
                      user,
                      rewardName,
                    } = row;
                    // const isItemSelected = selected.indexOf(nickname) !== -1;

                    return (
                      <TableRow hover key={id} tabIndex={-1} role="checkbox">
                        {" "}
                        {/* <TableCell padding="checkbox">
                                        <Checkbox
                                          checked={isItemSelected}
                                          onChange={(event) => handleClick(event, uid)}
                                        />
                                      </TableCell> */}{" "}
                        {/* <TableCell component="th" scope="row" padding="none">
                                        <Stack direction="row" alignItems="center" spacing={2}>
                                          <Avatar alt={nickname} src={`${BASE_URL}${avatar}`} />
                                          <Typography variant="subtitle2" noWrap>
                                            {nickname || uid}
                                          </Typography>
                                        </Stack>
                                      </TableCell> */}{" "}
                        <TableCell align="left">
                          <UserInfo {...user} />{" "}
                        </TableCell>{" "}
                        <TableCell align="left"> {code} </TableCell>{" "}
                        {/* <TableCell align="left">{buyCount}</TableCell> */}{" "}
                        {/* <TableCell align="left">{totalPrice}</TableCell>
                                    <TableCell align="left">{payPrice}</TableCell>
                                    <TableCell align="left">{PAY_METHOD_MAP[payMethod]}</TableCell> */}{" "}
                        <TableCell
                          align="left"
                          sx={{
                            minWidth: 120,
                          }}
                        >
                          <Stack>
                            <Typography>
                              {codeType == 1
                                ? "门票"
                                : codeType == 2
                                  ? "年会专区"
                                  : codeType == 3
                                    ? "大项目部"
                                    : codeType == 4
                                      ? "积分兑换"
                                      : codeType == 5
                                        ? "低保领取"
                                        : ""}
                            </Typography>
                          </Stack>
                          {/* <Label
                                        variant="ghost"
                                        color={ConvertUtil.getOrderStatusColor(status)}
                                      >
                                        {ConvertUtil.getOrderStatusText(status)}
                                      </Label> */}{" "}
                        </TableCell>{" "}
                        <TableCell
                          align="left"
                          sx={{
                            minWidth: 200,
                          }}
                        >
                          {rewardName}
                          {/* {productData.map((p) => (
                                        <Stack direction="row" spacing={1}>
                                          {<CellImage src={p.cover} style={{width: 60, height: 60, objectFit: "contain"}}/> }
                                          <Stack>
                                            <Typography>{p.name}</Typography>
                                            <Typography>x{p.count}</Typography>
                                          </Stack>
                                        </Stack>
                                      ))} */}
                        </TableCell>
                        <TableCell
                          align="left"
                          sx={{
                            minWidth: 100,
                          }}
                        >
                          <Stack>
                            <Typography>
                              {prizeType == 1
                                ? "虚拟物品"
                                : prizeType == 2
                                  ? "实物奖品"
                                  : ""}
                            </Typography>
                          </Stack>
                        </TableCell>
                        <TableCell
                          align="left"
                          sx={{
                            minWidth: 100,
                          }}
                        >
                          {izUsed === "true" || izUsed === true
                            ? "已使用"
                            : "未使用"}
                        </TableCell>
                        <TableCell
                          align="left"
                          sx={{
                            minWidth: 170,
                          }}
                        >
                          {receiverAddress == "" || receiverAddress == null ? (
                            ""
                          ) : (
                            <Stack>
                              <span>订单号: {orderSN} </span>{" "}
                              <span>收货人姓名: {receiverName} </span>{" "}
                              <span>收货人电话: {receiverMobile} </span>{" "}
                              <span>收货地址: {receiverAddress} </span>
                            </Stack>
                          )}
                        </TableCell>
                        {/* <TableCell align="left">{userRemark}</TableCell> */}{" "}
                        <TableCell
                          align="left"
                          sx={{
                            minWidth: 120,
                          }}
                        >
                          {" "}
                          {createdAt}{" "}
                        </TableCell>
                        <TableCell
                          align="right"
                          sx={{
                            minWidth: 120,
                          }}
                        >
                          {prizeType == 2 && izProcess == false ? (
                            <Button variant="text" onClick={() => Details(row)}>
                              去处理
                            </Button>
                          ) : (
                            ""
                          )}
                          {/* <MoreMenu spread={false} menus={filterMoreMenus(status)}
                                                onMoreClick={(title) => handleMoreClick(title, row)}/> */}{" "}
                        </TableCell>{" "}
                      </TableRow>
                    );
                  })}{" "}
                  {emptyRows > 0 && (
                    <TableRow
                      style={{
                        height: 53 * emptyRows,
                      }}
                    >
                      <TableCell colSpan={6}/>{" "}
                    </TableRow>
                  )}{" "}
                </TableBody>{" "}
                {orders.length === 0 && (
                  <TableBody>
                    <TableRow>
                      <TableCell
                        align="center"
                        colSpan={6}
                        sx={{
                          py: 3,
                        }}
                      >
                        <SearchNotFound searchQuery={filter.search}/>{" "}
                      </TableCell>{" "}
                    </TableRow>{" "}
                  </TableBody>
                )}{" "}
              </Table>{" "}
            </TableContainer>{" "}
          </Scrollbar>
          <Stack
            direction="row"
            alignItems="center"
            justifyContent="space-between"
          >
            <Stack
              direction="row"
              sx={{
                p: 2,
              }}
            >
              {" "}
              {/* <Typography variant="caption" component="span">
                      预期利润：{100}
                    </Typography>
                    <Divider orientation="vertical" flexItem sx={{mx: 1}} />
                    <Typography variant="caption" component="span" >
                      完单利润：{100}
                    </Typography> */}{" "}
            </Stack>{" "}
            {/* <TablePagination
              labelRowsPerPage="每页行数"
              rowsPerPageOptions={[10, 20]}
              component="div"
              count={totalItems}
              rowsPerPage={filter.size}
              page={filter.page}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
            />{" "} */}
            <MyPagination
              total={totalItems}
              page={filter.page}
              size={filter.size}
              onChange={handlePageChange}
              onSizeChange={handleSizeChange}
            />
          </Stack>{" "}
        </Card>{" "}
      </Container>
      {/* 详情 */}{" "}
      <OrderDetailDialog
        order={curOrder}
        open={action === "detail"}
        onClose={() => setAction()}
      />
      {/* 记录 */}{" "}
      <OrderRecordsDialog
        rows={records}
        open={action === "records"}
        onClose={() => setAction()}
      />
      <FormDialog
        title={`订单${curOrder.orderSN}备注`}
        open={action === "remark"}
        onConfirm={handleDialogConfirm}
        onClose={() => setAction()}
      >
        <TextField
          autoComplete="false"
          autoFocus
          id="adminRemark"
          value={remark}
          label="管理员备注"
          fullWidth
          variant="standard"
          onChange={(e) => setRemark(e.target.value)}
        />{" "}
      </FormDialog>
      <FormDialog
        title={`订单${curOrder.orderSN}发货`}
        open={action === "delivery"}
        onConfirm={handleDialogConfirm}
        onClose={() => setAction()}
      >
        <TextField
          autoComplete="false"
          autoFocus
          id="transport"
          value={deliverySN}
          label="物流单号"
          placeholder="(选填)"
          fullWidth
          variant="standard"
          onChange={(e) => setDeliverySN(e.target.value)}
        />{" "}
      </FormDialog>
      <FormDialog
        title={`订单${curOrder.orderSN}核销`}
        open={action === "hexiao"}
        onConfirm={handleConfirmHexiao}
        onClose={() => setAction()}
      >
        <TextField
          autoComplete="false"
          autoFocus
          id="transport"
          value={verifyCode}
          label="核销码"
          placeholder="(选填)"
          fullWidth
          variant="standard"
          onChange={(e) => setVerifyCode(e.target.value)}
        />{" "}
      </FormDialog>{" "}
      <FormDialog
        title="去处理"
        open={action === "tohandle"}
        onClose={() => {
          setAction();
          resetForm();
        }}
        onConfirm={handleDialogConfirm}
      >
        <FormItem title="商品ID">
          {/* <TextField fullWidth placeholder="请输入商品ID" autoComplete="off" id="pid" value={form.pid} size="small" disabled /> */}
          <TextField
            fullWidth
            placeholder="请输入商品ID"
            autoComplete="off"
            id="pid"
            value={form.pid || ""}
            size="small"
            onChange={(e) => handleIptChange("pid", e.target.value)} // 添加 onChange
          />
        </FormItem>
        {/* <FormItem title="中赢供应商标志" required>
          <RadioGroup row aria-label="gender" name="row-radio-buttons-group" value={form.isShow}>
            <FormControlLabel value={true} control={<Radio />} label="是" onChange={(e) => handleIptChange("isShow", e.target.value)} />
            <FormControlLabel value={false} control={<Radio />} label="否" onChange={(e) => handleIptChange("isShow", e.target.value)} />
          </RadioGroup>
        </FormItem> */}
        <FormItem title="收货人姓名" required>
          <TextField
            fullWidth
            placeholder="请输入收货人姓名"
            autoComplete="off"
            id="receiverName"
            value={form.receiverName}
            size="small"
            onChange={(e) => handleIptChange("receiverName", e.target.value)} // 添加 onChange
          />
        </FormItem>
        <FormItem title="收货人电话" required>
          <TextField
            fullWidth
            placeholder="请输入收货人电话"
            autoComplete="off"
            id="receiverMobile"
            value={form.receiverMobile}
            size="small"
            onChange={(e) => handleIptChange("receiverMobile", e.target.value)} // 添加 onChange
          />
        </FormItem>
        <FormItem title="收货人地址" required>
          <TextField
            fullWidth
            placeholder="请输入收货人地址"
            autoComplete="off"
            id="receiverAddress"
            value={form.receiverAddress}
            size="small"
            multiline // 添加这个属性使其成为多行文本框
            rows={4} // 可以指定显示的行数，根据需要调整
            onChange={(e) => handleIptChange("receiverAddress", e.target.value)}
          />
        </FormItem>
        <FormItem title="备注">
          <TextField
            fullWidth
            placeholder="请输入"
            autoComplete="off"
            id="receiverAddress"
            value={form.remark}
            size="small"
            multiline // 添加这个属性使其成为多行文本框
            rows={4} // 可以指定显示的行数，根据需要调整
            onChange={(e) => handleIptChange("remark", e.target.value)}
          />
        </FormItem>
      </FormDialog>
      <FormDialog
        title="发放抽奖码"
        open={action === "addCodes"}
        onClose={() => {
          setAction();
          resetForm();
        }}
        onConfirm={handleDialogConfirm}
        // onConfirm={handleAddCodes}
      >
        <FormItem title="抽奖码数量" required>
          <TextField
            fullWidth
            placeholder="请输入抽奖码数量"
            autoComplete="off"
            id="count"
            value={productForm.count || ""}
            size="small"
            type="number"
            onChange={(e) => handleIptChangeTwo("count", e.target.value)} // 添加 onChange
          />
        </FormItem>
        <FormItem title="码类型" required>
          <Select
            fullWidth
            value={productForm.codeType || ""}
            onChange={(e) => handleIptChangeTwo("codeType", e.target.value)}
            size="small"
          >
            {codeTypeList.map((type, idx) => (
              <MenuItem key={idx} value={type} name={type}>
                {codeTypeNum[type]}
              </MenuItem>
            ))}
          </Select>
        </FormItem>
        <FormItem title="手机号" required>
          <TextField
            fullWidth
            placeholder="请输入手机号"
            autoComplete="off"
            id="count"
            value={productForm.mobile || ""}
            size="small"
            type="number"
            onChange={(e) => handleIptChangeTwo("mobile", e.target.value)} // 添加 onChange
          />
        </FormItem>
        <FormItem title="活动类型" required>
          <Select
            fullWidth
            value={productForm.partyVersion}
            onChange={(e) => {
              setProductForm({
                ...productForm,
                partyVersion: e.target.value,
              });
            }}
            size="small"
          >
            {partyVersionList.map((type, idx) => (
              <MenuItem key={idx} value={type} name={type}>
                {partyVersionWrap[type]}
              </MenuItem>
            ))}{" "}
          </Select>{" "}
        </FormItem>
        <FormItem title="操作密码" required>
          <TextField
            fullWidth
            placeholder="请输入操作密码"
            autoComplete="off"
            id="password"
            value={productForm.password}
            size="small"
            type="password"
            onChange={(e) => handleIptChangeTwo("password", e.target.value)}
          />
        </FormItem>
      </FormDialog>
    </Page>
  );
}
